import { createContext } from "react";

export type AppConfig = {
  dateFormat: string,
  dateTimeFormat: string,
  timeFormat: string,
  dataFormatMoment: string,
  dataTimeFormatMoment: string,
  timeFormatMoment: string,
  serverDateTimeFormatMoment: string,
  serverDateFormatMoment: string,
  timeZone: string,
  serverTimeZone: string,
  pageTitlePrefix: string,
  googleApiKey: string
}

export const defaultAppConfig: AppConfig = {
  dateFormat: "MM/dd/yyyy",
  dateTimeFormat: "MM/dd/yyyy HH:mm",
  timeFormat: "HH:mm",
  dataFormatMoment: "MM/DD/YYYY",
  dataTimeFormatMoment: "MM/DD/YYYY HH:mm",
  timeFormatMoment: "HH:mm",
  serverDateTimeFormatMoment: "YYYY-MM-DDTHH:mm:ss.SSSS",
  serverDateFormatMoment: "YYYY-MM-DD",
  timeZone: "America/New_York",
  // timeZone: "Europe/Kiev"
  serverTimeZone: "America/New_York",
  // serverTimeZone: "UTC",
  pageTitlePrefix: "",
  googleApiKey: "AIzaSyCNNUJoJsBoPvMDK-e5J1x43K3DZbAfFvo",
};

Object.freeze(defaultAppConfig);

export const AppConfigContext = createContext<AppConfig>(defaultAppConfig);

export default AppConfigContext;
